function getClient(state: any) {
  return state.clients.getClient;
}

export default {
  getClient,
};
